/**
 * Componente: ModalEditarUsuario
 * 
 * Descripción:
 * Este componente representa un modal para editar un usuario existente.
 * Permite:
 * - Modificar datos generales del usuario: Usuario, Nombre, Mail, Rol, Estado, Código Personal, Gerencia, Áreas de Consulta.
 * - Cambiar la contraseña del usuario con validación de confirmación.
 * - Gestionar permisos del usuario mediante un menú jerárquico tipo Accordion.
 * - Gestionar accesos web del usuario mediante checkboxes.
 * - Visualizar y editar accesos adicionales mediante el componente TablaAccesosCRUD.
 * - Mostrar notificaciones de éxito o error mediante Toast.
 * 
 * Tecnologías y librerías utilizadas:
 * - React (useState, useEffect, useRef, Fragment)
 * - Formik para manejo de formularios y validaciones.
 * - PrimeReact: InputText, Dropdown, Password, Button, Dialog, Accordion, Checkbox, TabView, TabPanel, MultiSelect, ProgressSpinner, Toast.
 * - Servicios propios para manejo de API, cifrado y Toast.
 * 
 * Props:
 * - userEdit: objeto del usuario a editar.
 * - getUsers: función para recargar la lista de usuarios.
 * - setuserEdit: función para actualizar o limpiar el usuario seleccionado.
 */

import React, { useState, useEffect, useRef, Fragment } from "react";
// Librerias de componentes
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Password } from 'primereact/password';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { classNames } from 'primereact/utils';
import { Checkbox } from 'primereact/checkbox';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { ProgressSpinner } from 'primereact/progressspinner';
import { MultiSelect } from "primereact";
import { Toast } from 'primereact/toast';
import { TabPanel, TabView } from "primereact/tabview";

// Componentes internos
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { TablaAccesosCRUD } from './TablaAccesos/TablaAccesosCRUD'

import { toastShow } from '../../../../Base/Services/ToastService'
import { encryptor } from "../../../../Base/Services/Crypto/Crypto";
import { getRoles } from "../../../../API/IT/Roles/RolesRequests";
import { getEstadosSecurity } from "../../../../API/Global/Status/StatusRequests";
import { changePermisos, getPermisos } from "../../../../API/IT/Permisos/PermisosRequests";
import { getMenus } from "../../../../Base/API/Menu/MenuRequests";
import { getListAccesoMenu } from "../../../../API/IT/Accesos/AccesosRequests";
import { getAccesosUser, updateAccesoUser, getAccesosTabla } from "../../../../API/IT/Usuarios/AccesosUserRequets";
import { getPersonal } from "../../../../API/RRHH/Personal/PersonalRequests";
import { getSecciones } from "../../../../API/RRHH/Secciones/SeccionesRequests";
import { getAreas } from "../../../../API/Global/Areas/AreasRequests";
import { updateUser, updatePassword } from "../../../../API/IT/Usuarios/UsersRequests";

// import "./ModalStyle.scss"
export const ModalEditarUsuario = ({ userEdit, getUsers, setuserEdit }) => {

    /** Estados principales */
    const [roles, setRoles] = useState([{}]);
    const [estados, setEstados] = useState([{}]);
    const [showMessage, setShowMessage] = useState(false);
    const [listAcceso, setListAcceso] = useState([]);
    const [personal, setPersonal] = useState([]);
    const [secciones, setSecciones] = useState([]);
    const [areas, setAreas] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    // const [formData, setFormData] = useState();
    const [usuarioDialog, setUsuarioDialog] = useState(false);
    const toast = useRef(null);
    // const [subNiveles, setSubNiveles] = useState([]);
    const [menu, setMenu] = useState([]);
    // const [menuInfo, setMenuInfo] = useState([]);
    // const [_niveles, _setNiveles] = useState([])
    const [permisos, setPermisos] = useState([]);
    const [accesosUser, setAccesosUser] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);

    /**
     * Obtiene los valores iniciales del usuario
     */
    const getValoresIniciales = async () => {
        const rolesTempo = await getRoles();
        const estadosTempo = await getEstadosSecurity();
        setRoles(rolesTempo);
        setEstados(estadosTempo);
        const a = await getAreas();
        setAreas(a);
        const sec = await getSecciones();
        setSecciones(sec);

        // Inicializa los valorees del formulario con Formik
        formik.setValues({
            ...userEdit,
            AreasConsulta: userEdit.AreasConsulta ? userEdit.AreasConsulta.map(e => areas.filter(a => a.IdArea === e)[0]) : null,
            IdSecciones: userEdit.IdSecciones ? userEdit.IdSecciones.map(e => sec.filter(a => a.CodigoSeccion === e)[0]) : null,
        })
        const perso = await getPersonal();
        setPersonal(perso);
        console.log({ a, sec });
    }

    /**
     * Funcion para editar el usuario
     */
    const editarUsuario = async () => {
        setLoading1(true);
        const user = {
            Usuario: formik.values?.Usuario,
            UserName: formik.values?.UserName,
            Mail: formik.values?.Mail,
            // Password: formik.values?.Password === "" ? 
            IdRol: formik.values?.IdRol,
            Status: formik.values?.IdStatus,
            idUser: formik.values?.idUser,
            idpersonal: formik.values?.idPersonal ? formik.values?.idPersonal : null,
            Secciones: formik.values?.IdSecciones ? formik.values?.IdSecciones.map(e => e?.CodigoSeccion).toString() : null,
            AreasConsulta: formik.values?.AreasConsulta ? formik.values?.AreasConsulta.map(e => e.IdArea).toString() : null,
        }

        // Actualiza usuario
        const res = await updateUser(user);
        if (res?.code === "EREQUEST") {
            toastShow(toast, 'error', 'Error', 'Error al modificar el usuario');
        } else {
            getUsers()
            toastShow(toast, 'success', 'Modificado', 'Usuario Modificado Correctamente.');
            onHide()
        }

        // Si se cambió la contraseña, se actualiza también
        if (formik.values?.Password) {
            const user = {
                Password: await encryptor(formik.values?.ConfirmarPassword),
                idUser: await encryptor(formik.values?.idUser + '')
            }
            const res = await updatePassword(user);
            if (res?.code === "EREQUEST") {
                toastShow(toast, 'error', 'Error', 'Error al modificar el usuario');
                setLoading1(false);
            } else {
                getUsers()
                toastShow(toast, 'success', 'Modificdo', 'Usuario Modificado Correctamente.');
                onHide()
                setLoading1(false);
                // postCorreoContraseña()
            }
        }
        setLoading1(false);
    }

    /**
     * Formik para manejar formulario
     */
    const formik = useFormik({
        initialValues: userEdit,

        validate: (data) => {

            let errors = {};
            if (!data.Usuario) {
                errors.Usuario = 'Se requiere el Usuario.';
            }
            if (!data.UserName) {
                errors.UserName = 'Se requiere el Nombre.';
            }
            // else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
            //     errors.Mail = 'Correo Electronico Ivalido. E.g. example@email.com';
            // }
            if (data.Password !== data.ConfirmarPassword) {
                errors.Password = 'Las contraseñas no coinciden, ingreselas correctamente.';
            }

            if (!data.IdStatus) {
                errors.Status = 'Se requiere el estado del usuario.';
            }
            if (!data.IdRol) {
                errors.IdRol = 'Se requiere el Rol del usuario.';
            }

            return errors;
        },

        onSubmit: async (data) => {
            if (isFormFieldValid) {
                await editarUsuario();
            }
            else {
                console.log('Error');

                setShowMessage(true);

            }

        }
    });

    /**
     * Funciones auxiliares de validación Formik
     * @param {string} name - Nombre del campo a validar
     * @returns {boolean} - Indica si el campo ha sido tocado y tiene errores
     */
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    /**
     * Retorna el componente de mensaje de error si el campo no es válido
     * @param {string} name - Nombre del campo
     * @returns {JSX.Element | boolean} - El mensaje de error formateado o false
     */
    const getFormErrorMessage = (name) => {

        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;

    };

    /**
     * Obtiene y formatea los permisos y accesos de un usuario específico
     * @param {number} idUser - ID del usuario a consultar
     */
    const getPermisosUsuario = async (idUser) => {
        setIsLoading(true);
        const resp = await getPermisos(idUser);
        const ac = await getAccesosUser(idUser);
        console.log({ resp, ac });
        if (ac.length > 0) {
            setAccesosUser(ac[0].AccesosWeb.split(',').sort());
        }
        if (resp?.code === "EREQUEST") {
            toastShow(toast, 'error', 'Error', 'Error al obtener los permisos');
            setIsLoading(false);
        } else {
            setIsLoading(false);
            console.log(resp);
            const ordenado = resp[0].PermisosWeb.split(',').sort();
            setPermisos(ordenado);
        }
    }

    /**
     * Construye la jerarquía de submenús y niveles
     */
    const setSubMenu = (base, menuTempo) => {
        return base.map((item, i) => {
            let subNivel = []
            let t = menuTempo.filter((element) => element.IdContenedor === item.IdMenu)
            let subs = []
            t.map(e => menuTempo.forEach((element) => {
                if (element.IdContenedor === e.IdMenu) {
                    subs.push(element)
                }
            }));
            subNivel = [...t, ...subs]

            let subNiveles = [];
            subNivel.forEach((subItem, i) => {
                subNiveles.push(checkbox(subItem));
            })

            return (
                getNivelEncabezado(item, subNiveles)
            )
        })
    }

    /**
     * Obtiene la información inicial de menús y accesos generales
     */
    const getInfo = async () => {
        const menuTempo = await getMenus();
        const t = await getListAccesoMenu();
        if (t.length > 0) {
            setListAcceso(t);
        }
        let html = '';
        const base = menuTempo.filter((element) => element.IdContenedor === 0);
        html = setSubMenu(base, menuTempo)
        setMenu(html)
    }

    /**
      * Renderiza el encabezado de un nivel de menú dentro de un Accordion
      * @param {Object} item - Objeto del menú (IdMenu, Menu, Icon)
      * @param {JSX.Element[]} subNiveles - Arreglo de componentes checkbox renderizados
      * @returns {JSX.Element} Componente AccordionTab
      */
    const getNivelEncabezado = (item, subNiveles) => {
        return (
            <AccordionTab
                key={item.IdMenu}
                header={
                    <React.Fragment>
                        <div className="modal__permisosCheck">
                            <span >
                                <i className={item.Icon}></i>
                                {item.Menu}
                            </span>
                            <span >
                                <Checkbox value={item.IdMenu} onChange={onPermisosSubNivelChange}
                                    // checked={true} />
                                    checked={permisos.some((IdMenu) => IdMenu === (item.IdMenu + ''))} />
                            </span>
                        </div>
                    </React.Fragment>
                }
            >
                <div className='gridCheckbox'>
                    {subNiveles}
                    {/* {NivelesContainer.length > 0 ? <Accordion className={classNames("accordion-custom modal_accordion", { 'isNotVisible': isLoading })} multiple >{NivelesContainer}</Accordion>  : ''} */}
                </div>
            </AccordionTab >
        )
    }

    /**
     * Renderiza un checkbox individual para subniveles de menú
     * @param {Object} subNivel - Objeto del submenú
     * @returns {JSX.Element}
     */
    const checkbox = (subNivel) => {
        return (
            // <div>
            //     <h1>{subNivel.Nivel}</h1>
            <div key={subNivel.IdMenu} className="field-checkbox">
                <Checkbox inputId={subNivel.IdMenu} name="category" value={subNivel.IdMenu} onChange={onPermisosSubNivelChange}

                    checked={permisos.some((item) => item === (subNivel.IdMenu + ''))} />
                <label htmlFor={subNivel.IdMenu}>{subNivel.Menu}</label>
            </div>
            // </div>

        )
    }

    /**
     * Renderiza el acordeón principal con la lista de accesos disponibles
     * @returns {JSX.Element} Componente Accordion con tabs de accesos
     */
    const showAccesos = () => {
        return <Accordion className={classNames("accordion-custom modal_accordion", { 'isNotVisible': isLoading })} multiple>
            {listAcceso.map(menu => <AccordionTab header={menu.Menu}>
                <div className="gridCheckbox">
                    {menu.Accesos.map(acceso => <div key={acceso.IdAcceso} className="field-checkbox">
                        <Checkbox inputId={acceso.IdAcceso} name="category" value={acceso.IdAcceso} onChange={changeAccesoUsuario}
                            checked={accesosUser.some((item) => item === (acceso.IdAcceso + ''))} />
                        <label className="px-2" htmlFor={acceso.IdAcceso}>{acceso.Acceso}</label>
                    </div>)}
                </div>
            </AccordionTab>)}
        </Accordion>
    }

    /**
      * Maneja el cambio de estado de los accesos web del usuario
      * @param {Object} e - Evento del checkbox de PrimeReact
      */
    const changeAccesoUsuario = async (e) => {
        const aquiEstoy = accesosUser.some((item) => item === (e.value + ''));
        let newAccesos = null;
        if (aquiEstoy) {
            newAccesos = accesosUser.filter(item => item !== (e.value + ''));
        } else {
            if (accesosUser[0] === '') {
                newAccesos = [(e.value + '')];
            } else {
                newAccesos = [...accesosUser, (e.value + '')];
            }
        }
        const result = await updateAccesoUser({
            AccesosWeb: newAccesos.sort().toString(),
            idUser: userEdit.idUser
        });
        if (result.length > 0) {
            setAccesosUser(result[0].AccesosWeb.split(',').sort());
        }
    }

    /**
     * Maneja el cambio de permisos de subnivel y actualiza la base de datos
     * @param {Object} e - Evento del checkbox
     */
    const onPermisosSubNivelChange = async (e) => {

        const aquiEstoy = permisos.some((item) => item === (e.value + ''))

        let newPermisos = undefined;
        if (aquiEstoy) {
            newPermisos = permisos.filter((item) => item !== (e.value + ''))
        } else {
            if (permisos[0] === '') {
                newPermisos = [(e.value + '')]
            } else {
                newPermisos = [...permisos, (e.value + '')]
            }
        }
        const result = await changePermisos({ permisos: newPermisos.sort().toString(), idUser: userEdit.idUser });
        setPermisos(result[0].PermisosWeb.split(','));
    }

    // UseEffect que obtiene las datos de las funciones para getRoles y getEstados para mostrar
    // la informacion en los Dropdown (Select de opciones)
    /**
     * 
     */
    useEffect(() => {
        if (usuarioDialog) {
            getInfo()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permisos, accesosUser, usuarioDialog])


    /**
     * 
     */
    const dialogFooter = <div className="flex justify-content-center">
        <Button label="OK" className="p-button-text" autoFocus onClick={() => setShowMessage(false)} /></div>;
    const passwordHeader = <h6>Elige Tu Contraseña</h6>;

    const passwordFooter = (
        <React.Fragment>
            <Divider />
            <p className="mt-2">Sugerencias</p>
            <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: '1.5' }}>
                <li>Necesita 2 numeros</li>
                <li>Minimo 6 characters</li>
            </ul>
        </React.Fragment>
    );

    /**
     * Limpia los estados y cierra los diálogos de edición
     */
    const onHide = () => {
        setUsuarioDialog(false);
        setShowDialog(false);
        setuserEdit(null);
        formik.resetForm();
    }


    useEffect(() => {
        if (userEdit) {
            getInfo();
            getValoresIniciales();
            setUsuarioDialog(true);
            getPermisosUsuario(userEdit.idUser);

            // formik.setValues({
            //     ...userEdit,
            //     AreasConsulta: userEdit.AreasConsulta ?  userEdit.AreasConsulta.map(e => areas.filter(a => a.IdArea === e)[0]) : null,
            //     IdSecciones: userEdit.IdSecciones ? userEdit.IdSecciones.map(e => secciones.filter(a => a.CodigoSeccion === e)[0]): null,
            // })
        }
        if (userEdit) {
            setShowDialog(true);
        } else {
            setShowDialog(false);
        }
    }, [userEdit])

    /**
     * Template para mostrar el ID y nombre del empleado en componentes de selección
     * @param {Object} e - Objeto del empleado
     * @returns {string} Texto formateado
     */
    const personalTemplate = (e) => {
        return `${e?.idpersonal} - ${e?.NombreEmpleado}`
    }



    // const getInfoAcceso = async (data) => {

    //     const tempo = [...accesosUser]

    //     if(!data) return;

    //     const index = tempo.findIndex(Usuario =>
    //         Usuario?.Usuario === data?.Usuario
    //     );

    //     const tablaAccesos = await getAccesosTabla();
    //     setListadoAccesosTabla(tablaAccesos);
    //     console.log('Accesos Tabla: ', tablaAccesos);
    // }


    return (
        <Fragment>
            <div className="form-demo">
                <Toast position="bottom-right" ref={toast} />
                {/* <Dialog visible={showDialog} onHide={() => setShowMessage(false)} position="top" footer={dialogFooter} closable={true}
                    showHeader={false} breakpoints={{ '960px': '80vw' }} style={{ width: '30vw' }}>
                    <div className="flex align-items-center flex-column pt-6 px-3">
                        <i className="pi pi-check-circle" style={{ fontSize: '5rem', color: 'var(--green-500)' }}></i>
                        <h5 className="colorh5">Registro Creado Existosamente</h5>
                    </div>
                </Dialog> */}
                <div className="flex justify-content-center" >
                    <Dialog id="editModal1" visible={showDialog} header="Editar Usuario" modal className="modal__contenedor modal__usuarios"
                        onHide={onHide}>
                        <form onSubmit={formik.handleSubmit} className="p-fluid" style={{ margin: "Auto" }}>

                            <TabView>

                                <TabPanel header={'Datos Generales'}>

                                    <div style={{ display: "none" }}>
                                        <div className="field col-6 me-2">
                                            <span className="p-float-label">
                                                <InputText id="Usuario" name="Usuario" value={formik.values?.idUser} onChange={formik.handleChange} autoFocus
                                                    className={classNames({ 'p-invalid': isFormFieldValid('Usuario') })} />
                                            </span>
                                            {getFormErrorMessage('Usuario')}
                                        </div>
                                    </div>
                                    <div className="modal__input-contenedor" >
                                        <div className="field col-6 me-2" >
                                            <span className="p-float-label">
                                                <InputText id="Usuario" name="Usuario" value={formik.values?.Usuario} onChange={formik.handleChange} autoFocus
                                                    className={classNames({ 'p-invalid': isFormFieldValid('Usuario') })} />
                                                <label htmlFor="Usuario" className={classNames({ 'p-error': isFormFieldValid('Usuario') })}>Usuario</label>
                                            </span>
                                            {getFormErrorMessage('Usuario')}
                                        </div>
                                        <div className="field col-6 me-2">
                                            <span className="p-float-label">
                                                <InputText id="UserName" name="UserName" value={formik.values?.UserName} onChange={formik.handleChange} autoFocus
                                                    className={classNames({ 'p-invalid': isFormFieldValid('UserName') })} />
                                                <label htmlFor="UserName" className={classNames({ 'p-error': isFormFieldValid('UserName') })}>Nombre</label>
                                            </span>
                                            {getFormErrorMessage('UserName')}
                                        </div>
                                    </div>
                                    <div className="modal__input-contenedor">
                                        <div className="field col-6 me-2">
                                            <span className="p-float-label p-input-icon-right">
                                                <i className="pi pi-envelope" />
                                                <InputText id="Mail" name="Mail" value={formik.values?.Mail} onChange={formik.handleChange}
                                                    className={classNames({ 'p-invalid': isFormFieldValid('Mail') })} />
                                                <label htmlFor="Mail" className={classNames({ 'p-error': isFormFieldValid('Mail') })}>Correo</label>
                                            </span>
                                            {getFormErrorMessage('Mail')}
                                        </div>
                                        <div className="field col-6 me-2 accordion-demo" >
                                            <Accordion activeIndex={1} collapseIcon="pi pi-lock">
                                                <AccordionTab header="Cambiar Contraseña" >
                                                    <span className="p-float-label mt-3">
                                                        <Password id="Password" name="Password" value={formik.values?.Password} onChange={formik.handleChange} toggleMask
                                                            className={classNames({ 'p-invalid': isFormFieldValid('Password') })} header={passwordHeader} footer={passwordFooter} />
                                                        <label htmlFor="Password" className={classNames({ 'p-error': isFormFieldValid('Password') })}> Nuevo Password</label>
                                                    </span>
                                                    {getFormErrorMessage('Password')}

                                                    <span className="p-float-label mt-5">
                                                        <Password id="ConfirmarPassword" name="ConfirmarPassword" value={formik.values?.ConfirmarPassword} onChange={formik.handleChange} toggleMask
                                                            className={classNames({ 'p-invalid': isFormFieldValid('Password') })} header={passwordHeader} footer={passwordFooter} />
                                                        <label htmlFor="Password" className={classNames({ 'p-error': isFormFieldValid('Password') })}>Confirmar Password</label>
                                                    </span>
                                                    {getFormErrorMessage('Password')}
                                                </AccordionTab>
                                            </Accordion>

                                            {/* <Button label="Cambiar Contraseña" icon="pi pi-lock" className="p-button-text red" onClick={editPassword} /> */}
                                            {/* <span className="p-float-label">
                                                <Password id="Password" name="Password" value={formik.values?.Password} onChange={formik.handleChange} toggleMask
                                                    className={classNames({ 'p-invalid': isFormFieldValid('Password') })} header={passwordHeader} footer={passwordFooter} />
                                                <label htmlFor="Password" className={classNames({ 'p-error': isFormFieldValid('Password') })}>Password</label>
                                            </span>
                                            {getFormErrorMessage('Password')} */}
                                        </div>
                                    </div>

                                    <div className="modal__input-contenedor">
                                        <div className="field col-6 me-2">
                                            <label>Estado</label>
                                            <span className="p-float-label">
                                                <Dropdown id="IdStatus" name="IdStatus" value={formik.values?.IdStatus} onChange={formik.handleChange}
                                                    options={estados} optionLabel="StatusName" optionValue="IdStatus" />
                                            </span>
                                        </div>
                                        <></>
                                        <div className="field col-6 me-2">
                                            <label>Rol</label>
                                            <span className="p-float-label">
                                                <Dropdown id="IdRol" name="IdRol" value={formik.values?.IdRol} optionValue="IdRol" onChange={formik.handleChange} options={roles} optionLabel="Rol" />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="modal__input-contenedor">
                                        <div className="field col-6 me-2">
                                            <label>Código personal</label>
                                            <span className="p-float-label">
                                                <Dropdown id="idPersonal" name="idPersonal" value={formik.values?.idPersonal} onChange={formik.handleChange}
                                                    options={personal} optionLabel="NombreEmpleado" optionValue="idpersonal" filter showClear filterBy="NombreEmpleado" itemTemplate={personalTemplate} valueTemplate={personalTemplate} />
                                                {/* <label htmlFor="idPersonal" className={classNames({ 'p-error': isFormFieldValid('idPersonal') })}> Código personal</label> */}
                                            </span>
                                        </div>
                                        <></>
                                        <div className="field col-6 me-2">
                                            <label>Gerencia</label>
                                            <span className="p-float-label">
                                                <MultiSelect
                                                    options={secciones}
                                                    optionLabel={'Seccion'}
                                                    // optionValue="CodigoSeccion"
                                                    onChange={formik.handleChange}
                                                    value={formik.values?.IdSecciones}
                                                    id="IdSecciones"
                                                    name="IdSecciones"
                                                    filter
                                                    showClear
                                                    fixedPlaceholder={true}
                                                    display="chip"
                                                    disabled={!formik.values?.idPersonal}
                                                    zIndex={8898877}
                                                    style={{ zIndex: 9999999 }}
                                                />
                                            </span>
                                        </div>
                                        <></>
                                    </div>
                                    <div className="modal__input-contenedor">
                                        <div className="field col-6 me-2">
                                            <label>Areas Consulta</label>
                                            <span className="p-float-label">
                                                <MultiSelect
                                                    options={areas}
                                                    optionLabel={'Area'}
                                                    // optionValue="IdArea"
                                                    onChange={formik.handleChange}
                                                    value={formik.values?.AreasConsulta}
                                                    id="AreasConsulta"
                                                    name="AreasConsulta"
                                                    filter
                                                    showClear
                                                    fixedPlaceholder={true}
                                                    display="chip"
                                                />
                                            </span>
                                        </div>

                                    </div>

                                    <div className="p-dialog-footer">
                                        <Button label="Cancelar" type="button" icon="pi pi-times" className="p-button-text red" onClick={onHide} />
                                        <Button type="submit " loading={loading1} label="Guardar" icon="pi pi-check" className="p-button-text" />
                                    </div>
                                </TabPanel>

                                <TabPanel header={'Permisos'}>
                                    <div className="modal__input-contenedor">
                                        <h3 className="modal_texto-titulo-permisos">Permisos por usuario</h3>
                                    </div>
                                    <div className="modal__input-contenedor">
                                        <div className={classNames("progressSpinner-container", { 'isVisible': isLoading })}>
                                            <ProgressSpinner ></ProgressSpinner>
                                        </div>
                                        <Accordion className={classNames("accordion-custom modal_accordion", { 'isNotVisible': isLoading })} multiple >
                                            {
                                                menu
                                            }
                                        </Accordion>

                                    </div>
                                </TabPanel>

                                <TabPanel header={'Accesos'} >
                                    {listAcceso.length > 0 && <div>
                                        <div className="modal__input-contenedor">
                                            <h3 className="modal_texto-titulo-permisos">Accesos por usuario</h3>
                                        </div>
                                        <div className="modal__input-contenedor">
                                            {showAccesos()}
                                        </div>
                                    </div>}
                                </TabPanel>

                                <TabPanel header={'Tabla Accesos'} >
                                    {userEdit && <TablaAccesosCRUD userEdit={userEdit} />}
                                </TabPanel>

                            </TabView>


                            {/* <div style={{width: "80%", marginLeft: "10%", marginTop:"1%"}} className="card-container blue-container" >
                            <Button type="submit" label="Agregar" className="mt-2" onClick={agregarUsuario}/>
                        </div> */}

                        </form>
                    </Dialog>
                </div>
            </div>
        </Fragment>
    )
}

// Exportacion de la pantalla

export default ModalEditarUsuario;


